import { render } from "./ArrowRight.vue?vue&type=template&id=00c82f50"
import script from "./ArrowRight.vue?vue&type=script&lang=js"
export * from "./ArrowRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__